import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@/hooks/use-toast';
import { useTranslation } from '../useTranslation';
import { deleteSurcharge, surchargesQueryKeys } from '@api/surcharges';

interface UseDeleteSurchargeOptions {
  onSuccess?: () => void;
}

// Deletes a surcharge, then invalidates the surcharges list so the row drops
// out on refetch. Mirrors useDeleteLocation — invalidate-on-success (not optimistic).
export function useDeleteSurcharge(options?: UseDeleteSurchargeOptions) {
  const queryClient = useQueryClient();
  const { onSuccess } = options || {};
  const { t } = useTranslation();

  return useMutation({
    mutationFn: deleteSurcharge,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surchargesQueryKeys.lists() });
      toast({ description: t('destroy.success') });
      onSuccess?.();
    },
    onError: () => {
      // Deletes take no user input, so any failure is a generic infra/network
      // error — show the localized domain message, not a raw status string.
      toast({ description: t('destroy.error'), variant: 'destructive' });
    },
  });
}
